import { useDispatch, useSelector } from "react-redux";
import Step1 from "./payoutStep1/step1";
import Step2 from "./payoutStep2/step2";
import { TRootState } from "../../../../store";
import { Button } from "../../../../components/ui";
import { setCurrentSteps, setPayoutClick } from "../bloc/beneficiariesSlice";
import usePayout from "./usePayout";
import useBenficiaryOtpVerification from "../ben-otp-verification/useBenPayoutOtpVerication";

const PayoutsData = () => {

    const dispatch = useDispatch();

    const { currentSteps } = useSelector((state: TRootState) => ({
        currentSteps: state.beneficiary.currentSteps,
    }))

    const { onSubmitPayout, validateAddPayout } = usePayout();

    const { sendOtpApiCall, refId } = useBenficiaryOtpVerification({});

    return (
        <>
            {currentSteps === 1 && (
                <div className="bg-gray-bg">
                    <Step1 />
                </div>
            )}

            {currentSteps === 2 && (
                <div className="bg-gray-bg">
                    <Step2 />
                </div>
            )}

            <div className="bg-white flex absolute bottom-0 justify-between items-center gap-10 px-6 py-4 w-full border-t">

                {currentSteps === 1 ? (
                    <Button
                        className="w-[100px]"
                        onClick={() => {
                            dispatch(setPayoutClick(false));
                        }}
                        variant="transparent"
                    >
                        Cancel
                    </Button>
                ) : (
                    <Button
                        className="w-[100px]"
                        onClick={() => {
                            dispatch(setCurrentSteps(1));
                        }}
                        variant="transparent"
                    >
                        Previous
                    </Button>
                )}

                <Button
                    className="w-[100px]"
                    onClick={() => {
                        if (currentSteps === 1) {
                            if (validateAddPayout() && !refId) {
                                sendOtpApiCall("TP_PMT");
                                dispatch(setCurrentSteps(2));
                            }
                        } else {
                            onSubmitPayout();
                        }
                    }}
                    variant="contained"
                    disabled={currentSteps === 2 && !refId}
                >
                    Submit
                </Button>
            </div>

        </>
    )
}
export default PayoutsData;